import { ThemeEvents } from '@theme/events';

class DroplandProfitCalculator extends HTMLElement {
  connectedCallback() {
    this.quantities = this.getVariantQuantities();
    this.cost = this.costPerPiece(Number(this.dataset.cost || 0), this.dataset.initialVariantId);
    this.saleInput = this.querySelector('[data-calculator-sale]');
    this.saleInput?.addEventListener('input', () => this.render());
    document.addEventListener(ThemeEvents.variantUpdate, this.onVariantUpdate);
    this.render();
  }

  disconnectedCallback() {
    document.removeEventListener(ThemeEvents.variantUpdate, this.onVariantUpdate);
  }

  onVariantUpdate = (event) => {
    const variant = event.detail?.resource;
    const price = Number(variant?.price);
    if (Number.isFinite(price)) {
      this.cost = this.costPerPiece(price, variant?.id);
      this.render();
    }
  };

  getVariantQuantities() {
    try {
      return JSON.parse(this.querySelector('[data-calculator-variant-quantities]')?.textContent || '{}');
    } catch {
      return {};
    }
  }

  costPerPiece(totalPrice, variantId) {
    const quantity = Number(this.quantities?.[String(variantId)]) || 1;
    return totalPrice / 100 / quantity;
  }

  format(value) {
    return new Intl.NumberFormat('es-MX', { style: 'currency', currency: this.dataset.currency || 'MXN', maximumFractionDigits: 0 }).format(value);
  }

  render() {
    const sale = Math.max(0, Number(this.saleInput?.value || 0));
    const profit = sale - this.cost;
    const cost = this.querySelector('[data-calculator-cost]');
    const profitNode = this.querySelector('[data-calculator-profit]');
    if (cost) cost.textContent = this.format(this.cost);
    if (profitNode) profitNode.textContent = this.format(profit);
    this.querySelectorAll('[data-calculator-quantity]').forEach((card) => {
      const quantity = Number(card.dataset.calculatorQuantity || 0);
      const estimate = card.querySelector('[data-calculator-estimate]');
      if (estimate) estimate.textContent = this.format(profit * quantity);
    });
  }
}

if (!customElements.get('dropland-profit-calculator')) {
  customElements.define('dropland-profit-calculator', DroplandProfitCalculator);
}
